import React, {useRef, useState} from 'react';
import {Box, Typography} from '@mui/material';
import {Link} from 'react-router-dom';
import ArrMenu, {
  ArrMenuHandle,
  CustomMenuItem,
} from '../../../components/common/arr-menu/ArrMenu';
import '../Demo.scss';
import MenuIcon from '@mui/icons-material/Menu';
import SettingIcon from '@mui/icons-material/SettingsOutlined';
import ArrIconButton from '../../../components/common/arr-icon-button/ArrIconButton';

const MenuDemo: React.FC = () => {
  const sampleItems: CustomMenuItem[] = [
    {label: 'Data Imports', href: '/data-imports', id: 'data-imports'},
    {label: 'Analytics & Indexing', href: '/analytics', id: 'analytics'},
    {label: 'Unpublish', href: '/unpublish', id: 'unpublish'},
  ];

  const settingsSampleItems: CustomMenuItem[] = [
    {label: 'Home', href: '/home', id: 'home'},
    {label: 'Profile', href: '/profile', id: 'profile'},
    {label: 'About Us', href: '/aboutus', id: 'aboutus'},
    {
      id: 'file',
      label: 'File',
      submenu: [
        {id: 'open', label: 'Open'},
        {id: 'save', label: 'Save'},
        {id: 'save-as', label: 'Save As...'},
      ],
    },
  ];

  const menuRef1 = useRef<ArrMenuHandle | null>(null);
  const menuRef2 = useRef<ArrMenuHandle | null>(null);
  const [selectedMenuValue, setSelectedMenuValue] = useState<
    CustomMenuItem | undefined
  >(undefined);

  const onButtonClick1 = (e: React.MouseEvent<HTMLElement>) => {
    menuRef1.current?.open(e.currentTarget as HTMLElement);
  };

  const onButtonClick2 = (e: React.MouseEvent<HTMLElement>) => {
    menuRef2.current?.open(e.currentTarget as HTMLElement);
  };

  const onItemClick = (item: CustomMenuItem) => {
    setSelectedMenuValue(item);
  };

  return (
    <Box className="demo-page menu-demo">
      <h1>Menu</h1>
      <Typography>
        Menu component displays a list of items with links, toggles visibility
        on click, and automatically closes when the user clicks outside the
        menu.
      </Typography>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />

      <Box className="button-row">
        <Typography variant="h6" gutterBottom>
          Menu Examples
        </Typography>

        <Box
          display="flex"
          justifyContent="center"
          gap={4}
          mb={4}
          alignItems="center"
        >
          <Typography component="h2">Simple Menu</Typography>
          <ArrMenu
            id="arr-menu-1"
            ref={menuRef1}
            items={sampleItems}
            onItemClick={onItemClick}
            title="Manage"
            selectedCustomMenuItem={selectedMenuValue}
            direction="right"
          />
          <ArrIconButton
            onClick={onButtonClick1}
            size="medium"
            shape="default"
            icon={<MenuIcon />}
            ariaLabel="menu-icon"
          />
        </Box>

        <Box
          display="flex"
          justifyContent="center"
          gap={4}
          mb={4}
          alignItems="center"
        >
          <Typography component="h2">Nested Menu</Typography>
          <ArrMenu
            id="arr-menu-2"
            ref={menuRef2}
            items={settingsSampleItems}
            onItemClick={onItemClick}
            title="Settings"
            selectedCustomMenuItem={selectedMenuValue}
            direction="bottom"
          />
          <ArrIconButton
            onClick={onButtonClick2}
            size="medium"
            shape="default"
            icon={<SettingIcon />}
            ariaLabel="setting-icon"
          />
        </Box>

        {selectedMenuValue && (
          <Box mt={2} p={2} bgcolor="action.hover" borderRadius={1}>
            <Typography variant="body2">
              <strong>Selected Item:</strong> {selectedMenuValue.label}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MenuDemo;
